module.exports = __webpack_public_path__ + "static/media/header.868a1fac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header.jpg
// module id = 288
// module chunks = 5